import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import InputBox from './InputBox';
import _ from 'lodash';
import utf8 from 'utf8';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import FileUpload from './FileUpload';
import DragDropChannel from './drag/DragDropChannel';
import SnackBar from './SnackBar'

// okasboxes add new device

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '10%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


export default class EditChannelModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      errorMessage: [],
      array: '',
      name: this.props.currentChannel.channel_name,
      genre: this.props.currentChannel.genre,
      language: this.props.currentChannel.language,
      description: this.props.currentChannel.description===null ? '' : this.props.currentChannel.description,
      number: this.props.currentChannel.channel_number,
      modalIsOpenSuccess: false,
      showErrorMessage: false,
      loader: false,
      logourl: this.props.currentChannel.logo_url,
      logourlBase64: '',
      fileNameCompleteReleaseNote: '',
      logoChanged: false,
      snackbarActive: false,
      snackbarMessage: ''
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }


  componentWillMount(){
    this.setState({
      array:this.channelArrayHandler(this.props.currentChannel.channel_number)
    })
  }


  closeModalSuccess() {
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpenSuccess: false
        }, () => this.props.refreshDevices())
      }, 500);

    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        })
        this.props.refreshDevices()
      }, 500);
    })
  }

  AddChannel = (e) => {
    let channel_name = this.state.name;
    let genre = this.state.genre;
    let channel_array = this.state.array.split('');
    channel_array = channel_array.map((e)=>{
        return Number(e)
    })
    let channel_number = this.state.number;
    let language = this.state.language;
    let description = this.state.description;
    let logo = utf8.encode(this.state.logourlBase64.toString());
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
var xx;
    if(this.state.logourl===undefined){
       xx = JSON.stringify({
        channel_name,
        genre,
        channel_array,
        channel_number,
        logo,
        language,
        description
      })
    }else{
      xx = JSON.stringify({
        channel_name,
        genre,
        channel_array,
        channel_number,
        language,
        description
      })
    }

    fetch(`/cloud/d2hlistApi_detail/${this.props.currentChannel.ID}`, {
      method: "PUT",
      headers: headers,
      body: xx
    })
    .then(response => {
      if(response.status===403){
        localStorage.removeItem('token');
        localStorage.removeItem('csrftoken');
        localStorage.removeItem('auth');
        // const history = createHistory({forceRefresh: true})
        window.location.href ='/session-timeout'
      }else{
          return response.json()}
      })
      .then(response => {
        if (response.message === 'success') {
          this.setState({
            modalIsOpen: false,
            modalIsOpenSuccess: true,
            loader: false
          })
        }
        else {
          let data = response.data;
          let index = Object.keys(data)[0]
          console.log(index + ": " + data[Object.keys(data)[0]])
         let  errorLog = index + ": " + data[Object.keys(data)[0]]
          this.setState({
            loader: false,
            snackbarActive: true,
            snackbarMessage: errorLog
          })

        }
      })
      .catch((err)=>{
        console.log(err)

      })
  }

  handleChangeInputBox = (name, event) => {   
    if(name!=='number'){
      this.setState({
        [name]: event
      })
    }else if(name==='number'){
       let customArray = `0000${event}`;
        this.setState({
          array: customArray.slice(-4),
          [name]: event
        })
    }else if(name==='name'){
      this.setState({
        [name]: event,
        logourl: undefined,
        logourlBase64: ''
      })
   }
  };

  AddChannelhandler = () => {
    this.setState({
      showErrorMessage: true
    },()=>{
      this.fetchError((e)=>{
       if(e==='NoError'){
         this.setState({
           loader: true
         },()=>this.AddChannel())       
       }
      })
    })
  }

  channelArrayHandler = (number)=>{
    let customArray = `0000${number}`;
    customArray = customArray.slice(-4);
    return customArray;
}
  

  fetchError = (noError) => {
    var totalError;
    if(this.state.logourl===undefined){
      totalError = 6;
    }else{
      totalError = 5;
    }
    
    if(ErrorText('notEmpty', this.state.name.toString())==='No Error'){

      totalError=totalError-1;
    }
    
    if(ErrorText('validChannelNumber', this.state.number.toString())==='No Error'){
      totalError=totalError-1;
    }
    if(ErrorText('notEmpty', this.state.array.toString())==='No Error'){
      totalError=totalError-1;
    }
    if(ErrorText('notEmpty', this.state.genre.toString())==='No Error'){
      totalError=totalError-1;
    }
    if(ErrorText('notEmpty', this.state.language.toString())==='No Error'){
      totalError=totalError-1;
    }
    if(this.state.logourl===undefined){
     if(ErrorText('notEmpty', this.state.logourlBase64.toString())==='No Error'){      
        totalError=totalError-1;
      }else{
        this.setState({
          snackbarActive: true,
          snackbarMessage: 'Please upload logo for addding new channel'
        })
      }
    }
    if(totalError===0){
      noError('NoError');
    }else{
      console.log('err exist')
    }
    }

  render() {
    return (
      <React.Fragment>
            <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
        {this.state.loader ? <Loader /> : null}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase" style={{ color: '#888888', fontSize: '30px', marginBottom: '30px' }}>Edit Channel</h3>
          <div className="col-12 p-0 m-0" style={{ height: '400px' }}>
            <div className="col-7 p-0 m-0" style={{ display: 'inline', float: 'left' }}>
              <div className="row" style={{ margin: '0px', padding: '0px' }}>
                <div className="col-10 pl-0 " style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.name}
                    placeholder="Channel Name"
                    inputBoxName="name"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={50}
                    validate={true}
                    error={ErrorText('notEmpty', this.state.name)!=='No Error' && this.state.showErrorMessage  ? true : false}
                    errorText={ErrorText('notEmpty', this.state.name)!=='No Error' && this.state.showErrorMessage ? 'Please enter channel name' : ''}
                  />
                </div>
              </div>
              <div className="row" style={{ margin: '0px', padding: '0px' }}>
                <div className="col-10 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.number}
                    placeholder="Channel Number"
                    inputBoxName="number"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={4}
                    validate={true}
                    isNumber={true}  
                    error={ErrorText('validChannelNumber', this.state.number.toString())!=='No Error' && this.state.showErrorMessage  ? true : false}
                    errorText={ErrorText('validChannelNumber', this.state.number.toString())!=='No Error' && this.state.showErrorMessage ? 'Please enter channel number' : ''}
                  />
                </div>
              </div>
              <div className="row" style={{ margin: '0px', padding: '0px', pointerEvents: 'none' }}>
                <div className="col-10 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.array}
                    placeholder={this.state.array!=='' ? "CHANNEL ARRAY" : "Channel Array"}
                    inputBoxName="array"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={4}
                    validate={true}
                    exportValue={true}    
                    isNumber={true}     
                    error={ErrorText('notEmpty', this.state.array)!=='No Error' && this.state.showErrorMessage  ? true : false}
                    errorText={ErrorText('notEmpty', this.state.array)!=='No Error' && this.state.showErrorMessage ? 'Please enter channel array' : ''}               
                  />
                </div>
              </div>
              <div className="row" style={{ margin: '0px', padding: '0px' }}>
                <div className="col-10 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.genre}
                    placeholder="Genre"
                    inputBoxName="genre"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={50}
                    validate={true}
                    error={ErrorText('notEmpty', this.state.genre.toString())!=='No Error' && this.state.showErrorMessage  ? true : false}
                    errorText={ErrorText('notEmpty', this.state.genre.toString())!=='No Error' && this.state.showErrorMessage ? 'Please enter genre' : ''}
                  />
                </div>
              </div>
              <div className="row" style={{ margin: '0px', padding: '0px' }}>
                <div className="col-10 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.language}
                    placeholder="Language"
                    inputBoxName="language"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={50}
                    validate={true}
                    error={ErrorText('notEmpty', this.state.language.toString())!=='No Error' && this.state.showErrorMessage  ? true : false}
                    errorText={ErrorText('notEmpty', this.state.language.toString())!=='No Error' && this.state.showErrorMessage ? 'Please enter language' : ''}
                  />
                </div>
              </div>
              <div className="row" style={{ margin: '0px', padding: '0px' }}>
                <div className="col-10 pl-0" style={{ padding: '0px', margin: '0px', marginLeft: '-9px' }}>
                  <InputBox
                    inputText={this.state.description}
                    placeholder="Description"
                    inputBoxName="description"
                    handleChangeCustom={this.handleChangeInputBox.bind(this)}
                    textLength={100}
                    validate={false}
                  />
                </div>
              </div>
            </div>
            <div className="col-5 mr-0" style={{ display: 'inline', float: 'right', backgroundColor: '#E0E0E0', borderRadius: '10px 10px 10px 10px' }}>
              <DragDropChannel
              logourl = {this.state.logourl}
                fileUpdate={(base64Data) => {
                  this.setState({
                    logourlBase64: base64Data,
                    logourl: undefined
                  })
                }}
              />
            </div>
          </div>
          <div className="float-right" style={{ marginTop: '70px', marginBottom: '70px' }}>
            <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Close</div>
            <div className="btn btn-new-green" onClick={this.AddChannelhandler.bind(this)}
            >Edit</div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2" onClick={this.closeModalSuccess}></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Channel edited successfully</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5"
              onClick={this.closeModalSuccess}
            >
              Close
                            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
